<tax-page-header titleText="menu.cto" [rightSide]="addCtoButton"></tax-page-header>
<ng-template #addCtoButton>
  <a class="like-button" routerLink="new" translate data-qa-link="create-cto">groups.add</a>
</ng-template>

<div class="ui-kit-tag-list" *ngIf="filteredContractsList?.length" data-qa-block="tag-list">
  <ng-template ngFor let-status [ngForOf]="statuses">
    <ng-template [ngIf]="status.counter">
      <div
        class="ui-kit-tag"
        [ngClass]="{ tag__selected: status.isSelected }"
        (click)="filterContracts(status.id)"
        [attr.data-qa-tag]="status.name"
      >
        <span translate data-qa="tag-name">cto.contracts.status.{{ status.name }}</span>
        <span data-qa="tag-counter" class="ui-kit-tag__counter" translate>{{
          status.counter
        }}</span>
      </div>
    </ng-template>
  </ng-template>
</div>

<div class="contract-list" data-qa-block="cto-list">
  <tax-contract
    *ngFor="let contract of filteredContractsList"
    [contract]="contract"
    (click)="goToCtoDetails(contract.id)"
  ></tax-contract>

  <ng-container *ngIf="!filteredContractsList?.length">
    <div class="not_found_block" translate data-qa-block="empty-list">
      <span translate data-qa="empty-list-text">cto.list.empty</span>
      <a class="link_button" routerLink="new" translate data-qa-link="create-cto"
        >cto.list.empty.link</a
      >
    </div>
  </ng-container>
</div>
